import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-muted",
        "before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer",
        // softer gradient for a smooth blend
        "before:bg-gradient-to-r before:from-transparent before:via-neutral-300/10 before:to-transparent",
        "dark:before:via-neutral-300/10", // adjusts for dark mode
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
